import React from 'react';
import { omit } from 'lodash';

// Shared components
import {
  Content,
  BlockImage,
  Breadcrumbs
} from '~/App/shared/components/Blocks';
import { PageFooter } from '~/App/shared/components/PageFooter';

export default class NewsPage extends React.Component {
  constructor(props) {
    super(props);

    this.heroRef = React.createRef();
  }

  render() {
    const {
      content = {},
      breadcrumbs = {},
      publishedAt = '',
      revisionDate = '',
      showBreadcrumbs = false,
      showPageFooter = true,
      author = {},
      editor = {},
      auditor = {},
      auditDate = null,
      sharingIcons = {},
      articleImage = {},
      template = ''
    } = this.props;

    const hasArticleImage =
      articleImage.large &&
      articleImage.large.source &&
      articleImage.large.source.secure_url;

    const preambleContent = omit(content, ['body']);
    const mainContent = omit(content, ['heading', 'preamble']);
    preambleContent.padding.bottom = 'tiny';
    mainContent.padding.top = 'tiny';

    return (
      <div>
        {showBreadcrumbs && <Breadcrumbs {...breadcrumbs} />}
        <div id={content.hash}>
          <Content
            {...preambleContent}
            padding={{ top: 'large', bottom: 'tiny' }}
            publishedAt={publishedAt}
            revisionDate={revisionDate}
          />
        </div>
        {hasArticleImage && <BlockImage {...articleImage} />}
        <div>
          <Content {...mainContent} template={template} />
        </div>
        {showPageFooter && (
          <PageFooter
            sharingIcons={sharingIcons}
            author={author}
            editor={editor}
            auditor={auditor}
            auditDate={auditDate}
            width={content.width}
          />
        )}
      </div>
    );
  }
}
